import "../inlineLinkElement/InlineLink.css.ts.vanilla.js";
import "./Text.css.ts.vanilla.js";
var r = "_1untytp0";
export {
  r as text
};
